import React from 'react';
import ErrorBoundary, {
  ErrorBoundaryModal
} from 'src/components/ErrorBoundary';
import { useLocation } from 'react-router';

const getDisplayName = (WrappedComponent) => {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

const withErrorBoundary = (WrappedComponent, type) => {
  const ErrorBoundaryWrapper = (props) => {
    const location = useLocation();

    if (type === 'modal') {
      return (
        <ErrorBoundaryModal location={location}>
          <WrappedComponent {...props} />
        </ErrorBoundaryModal>
      );
    }

    return (
      <ErrorBoundary location={location}>
        <WrappedComponent {...props} />
      </ErrorBoundary>
    );
  };

  if (type) {
    ErrorBoundaryWrapper.displayName = `withErrorBoundary(${getDisplayName(
      WrappedComponent
    )}, ${type})`;
  } else {
    ErrorBoundaryWrapper.displayName = `withErrorBoundary(${getDisplayName(
      WrappedComponent
    )})`;
  }

  return ErrorBoundaryWrapper;
};

export default withErrorBoundary;
